import React, { useEffect, useState } from "react";
import "./EntryFormListing.scss";
import { TitleBar } from "../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../TopBar/TopBar";
import { IoSearchSharp } from "react-icons/io5";
import { GreyBackgroundButton, GreyfilterButton, RedBackgroundButton, ViewMoreButton } from "../../../Global/GlobalButton";
import { LuFilter } from "react-icons/lu";
import {
  GreenSubDescription,
  RedMainHeading,
  SubHeading,
} from "../../../Global/GlobalText";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { GlobalSecondTable } from "../../../Global/GlobalSecondTable/GlobalSecondTable";
import { EXCHNAGE_URL, USER_EXCHNAGE_URL } from "../../../../Url/Url";
import { FaEdit, FaPaperPlane } from "react-icons/fa";
import { ImBlocked } from "react-icons/im";
import { MdEditSquare } from "react-icons/md";
import { InputLabel, InputType } from "../../../Global/GlobalFormElement";
import { Modal } from "react-bootstrap";
import * as XLSX from 'xlsx';
import { GlobalFourthTable } from "../../../Global/GlobalFourthTable/GlobalFourthTable";
import { UserSubmissionDetails } from "../../../User-Flow-While-Registration/UserSubmissionDetails/UserSubmissionDetails";
import { AdminEdit } from "../../../User-Flow-While-Registration/UserSubmissionDetails/AdminEdit";
import { useLoading } from "../../../LoadingContext"; // ✅ ADD THIS

export const EntryFormListing = () => {
    const { setLoading } = useLoading(); // ✅ ADD THIS - Global loader

  const [fetchedEntryformData, setFetchedEntryformData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [submissionId, setSubmissionId] = useState("");
  const [loader, setLoader] = useState(false);
  const [entryFormId, setEntryFormId] = useState();
  const [registrationFormId, setRegistrationFormId] = useState();
  const [singleSelectedEntryData, setSingleSelectedEntryData] = useState(null);
  const [submissionUserId, setSubmissionUserId] = useState(null);
  const [sendingMail, setSendingMail] = useState(false);
  const eventIdGet = useSelector((state) => state?.users?.id);
  const eventId = String(eventIdGet);

  const token = localStorage.getItem("token");
// ✅ Add this helper function at the top of your component
const stripHTMLTags = (html) => {
  if (!html) return "";
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
};
  const getEntryListingFormData = async () => {
      setLoader(true);
    setLoading(true); // ✅ Start global loader

    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/entrantsData?eventId=${eventId}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            'Content-Type': "application/json"
          }
        }
      );
      if (response.status === 200) {
        toast.success("Data Fetched Successfully");
        const subData = response.data.data;
        setFetchedEntryformData(subData);
        console.log(subData, "subssssssss");
      } else {
        console.log("error while fetching data");
      }
    } catch (error) {
      toast.error("Error While Fetching Data");
      console.log(error, "error");
    }finally {
      setLoader(false);
            setLoading(false); // ✅ Stop global loader

}
  };

const downloadSelectedRecords = () => {
  if (selectedRows.length === 0) {
    toast.warning("No rows selected to export.");
    return;
  }

  // Get raw data directly from fetchedEntryformData
  const rawData = fetchedEntryformData?.mergedData || [];
  
  // Filter selected entries
  const selectedEntries = rawData.filter(entry => 
    selectedRows.includes(entry.submissionData?.submission_id)
  );

  if (selectedEntries.length === 0) {
    toast.warning("No matching records found for export.");
    return;
  }

  // Build field mapping - field_name to label
  const fieldMap = {};
const fieldNameToLabel = {};
[...(fetchedEntryformData?.formSchema?.registrationFields || []),
 ...(fetchedEntryformData?.formSchema?.entryFields || [])]
  .forEach(field => {
    // ✅ Remove HTML tags from label for export
    fieldNameToLabel[field.field_name] = stripHTMLTags(field.label);
    
    // Also map by normalized label for reverse lookup
    const normalizedLabel = stripHTMLTags(field.label).toLowerCase().replace(/\(default\)/gi, '').trim();
    fieldMap[normalizedLabel] = field.field_name;
  });

  const exportData = selectedEntries.map((entry) => {
    const row = {};

    // Add basic info with proper headers
    row['Submission ID'] = entry.submissionData?.submission_id || '';
    row['Status'] = entry.submissionData?.isDraft === 1 ? 'Draft' : 'Submitted';
    row['Payment'] = entry.submissionData?.paymentstatus || 'Unpaid';
    row['Created At'] = formatDate(entry.submissionData?.created_at);
    row['Updated At'] = formatDate(entry.submissionData?.updated_at);

    // Add registration fields with proper labels
    if (entry.registrationData?.fields) {
      entry.registrationData.fields.forEach(field => {
        const [key, value] = Object.entries(field).find(([k]) => k !== 'registrationDataId') || [];
        if (key) {
          // Try to find the label for this field
          let header = key;
          
          // First try to find by field_name
          if (fieldNameToLabel[key]) {
            header = fieldNameToLabel[key];
          } else {
            // Try normalized key
            const normalizedKey = key.toLowerCase().replace(/-/g, ' ');
            const fieldName = fieldMap[normalizedKey];
            if (fieldName && fieldNameToLabel[fieldName]) {
              header = fieldNameToLabel[fieldName];
            }
          }
          
          row[header] = value || '';
        }
      });
    }

    // Add admin registration data
    if (entry.registrationData?.role === "admin") {
      const adminFields = {
        'First Name': entry.registrationData?.first_name,
        'Last Name': entry.registrationData?.last_name,
        'Email': entry.registrationData?.email,
        'Country': entry.registrationData?.country
      };
      Object.entries(adminFields).forEach(([label, value]) => {
        if (value) row[label] = value;
      });
    }

    // Add submission fields with proper labels
    if (entry.submissionData?.fields) {
      entry.submissionData.fields.forEach(field => {
        const [key, value] = Object.entries(field).find(([k]) => k !== 'entryDataId') || [];
        if (key) {
          // Try to find the label for this field
          let header = key;
          
          // First try to find by field_name
          if (fieldNameToLabel[key]) {
            header = fieldNameToLabel[key];
          } else {
            // Try normalized key
            const normalizedKey = key.toLowerCase().replace(/-/g, ' ');
            const fieldName = fieldMap[normalizedKey];
            if (fieldName && fieldNameToLabel[fieldName]) {
              header = fieldNameToLabel[fieldName];
            }
          }
          
          row[header] = value || '';
        }
      });
    }

    return row;
  });

  // Create workbook
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(exportData);

  // Auto-size columns
  const colWidths = [];
  if (exportData.length > 0) {
    const headers = Object.keys(exportData[0]);
    headers.forEach((key, index) => {
      let maxLength = key.length;
      exportData.forEach(row => {
        const value = String(row[key] || '');
        maxLength = Math.max(maxLength, value.length);
      });
      colWidths[index] = { wch: Math.min(maxLength + 5, 60) };
    });
    worksheet['!cols'] = colWidths;
  }

  XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Records");
  XLSX.writeFile(workbook, "selected_records.xlsx");
  
  toast.success(`Exported ${exportData.length} records successfully!`);
};
const handleSelectAll = () => {
  const allIds = data.map((row) => row.submission_id);
  setSelectedRows(allIds);
};
 const handleDeselectAll = () => {
  setSelectedRows([]);
};
  const [mediaList, setMediaList] = useState([]);
  const [isMediaModalOpen, setIsMediaModalOpen] = useState(false);

  const handleMediaClick = async (mediaFiles) => {
    if (!mediaFiles || mediaFiles.length === 0) {
      alert("No media files available.");
      return;
    }

    const filesWithUrls = [];

    for (const file of mediaFiles) {
      try {
        const response = await fetch(`https://api.awardsuite.in/api/media/${file.id}`);
        const data = await response.json();

        if (!data.url) continue;

        filesWithUrls.push({
          id: file.id,
          name: file.file_name,
          mimeType: data.mimeType,
          url: data.url,
        });
      } catch (err) {
        console.error(`Error loading media: ${file.file_name}`, err);
      }
    }

    setMediaList(filesWithUrls);
    setIsMediaModalOpen(true);
  };

  const handleSingleMediaClick = (file) => {
    if (file.mimeType.startsWith("image/") || file.mimeType === "application/pdf") {
      window.open(file.url, "_blank");
    } else if (
      file.mimeType === "application/vnd.ms-powerpoint" ||
      file.mimeType === "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ) {
      const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(file.url)}&embedded=true`;
      window.open(viewerUrl, "_blank");
    } else {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

const handleCheckboxChange = (rowId, checked) => {
  if (!rowId) return;

  if (checked) {
    setSelectedRows((prev) => [...new Set([...prev, rowId])]);
  } else {
    setSelectedRows((prev) =>
      prev.filter((id) => id !== rowId)
    );
  }
};

  const handleRowClick = (row) => {
    console.log(row, "df");
  };

  const handleClose = () => {
    setShowModal(false);
    setFormValues({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };


  const singleSelectedEntryFormListingData = async (eventId, submissionId) => {
    setLoader(true);
        setLoading(true); // ✅ Start global loader

    try {
      const apiUrl = `${EXCHNAGE_URL}/entryDataById?eventId=${eventId}&submission_id=${submissionId}`;
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "Application/json",
          authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        setSingleSelectedEntryData(response.data.data.fetchfields.fields);
        setShowModal(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
            setLoading(false); // ✅ Stop global loader

    }
  };


  // const handleEditClick = (row) => {
  //   console.log("Edit clicked for entry:", row);
  //   const registrationDetails = row.registrationData?.fields.reduce((acc, field) => {
  //     const [key, value] = Object.entries(field).find(([k]) => k !== 'registrationDataId') || [];
  //     if (key) acc[key] = value;
  //     return acc;
  //   }, {});

  //   const submissionDetails = row.submissionData?.fields.reduce((acc, field) => {
  //     const [key, value] = Object.entries(field).find(([k]) => k !== 'entryDataId') || [];
  //     if (key) acc[key] = value;
  //     return acc;
  //   }, {});

  //   const updatedFormValues = {
  //     ...registrationDetails,
  //     ...submissionDetails,
  //     Category: row.submissionData?.fields.find(field => field.Category)?.Category || row.Category
  //   };

  //   setFormValues(updatedFormValues);
  //   setShowModal(true);
  //   setSubmissionId(row.submission_id);
  //   setRegistrationFormId(row.registrationData.registrationFormId);
  //   setEntryFormId(row.submissionData.entryFormId);
  //   console.log(row, "asssssssss");
  //   singleSelectedEntryFormListingData(eventId, row.submission_id);
  // };

  const handleEditClick = (row) => {
    console.log("Edit clicked for entry:", row);

    // ✅ SAFE registration
    const registrationDetails = (row.registrationData?.fields || []).reduce(
      (acc, field) => {
        const [key, value] =
          Object.entries(field).find(([k]) => k !== "registrationDataId") || [];

        if (key) acc[key] = value;
        return acc;
      },
      {}
    );

    // ✅ SAFE submission
    const submissionDetails = (row.submissionData?.fields || []).reduce(
      (acc, field) => {
        const [key, value] =
          Object.entries(field).find(([k]) => k !== "entryDataId") || [];

        if (key) acc[key] = value;
        return acc;
      },
      {}
    );

    const updatedFormValues = {
      ...registrationDetails,
      ...submissionDetails,
      Category:
        (row.submissionData?.fields || []).find((f) => f.Category)?.Category ||
        row.Category ||
        "",
    };

    setFormValues(updatedFormValues);
    setShowModal(true);
    setSubmissionId(row.submission_id);
    setRegistrationFormId(row.registrationData?.registrationFormId || null);
    setEntryFormId(row.submissionData?.entryFormId || null);
    setSubmissionUserId(row.submissionData?.created_by);

    // optional API
    singleSelectedEntryFormListingData(eventId, row.submission_id);
  };
  const updateEntryFormListingData = async (e) => {
        setLoading(true); // ✅ Start global loader

    const updates = Object.keys(formValues).map((key) => {
      const fieldData = singleSelectedEntryData?.find((item) => item[key] !== undefined);

      return fieldData
        ? {
          entryDataId: fieldData.entryDataId,
          field_name: key,
          field_value: formValues[key],
        }
        : null;
    }).filter(Boolean);

    const payload = {
      eventId: eventId,
      entryFormId: entryFormId,
      submission_id: submissionId,
      updates
    };

    try {
      const apiUrl = `${EXCHNAGE_URL}/entryDataEdit`;
      const response = await axios.put(apiUrl, payload, {
        headers: {
          "Content-Type": "Application/json",
          authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        console.log("Entry Form data updated successfully!");
        getEntryListingFormData();
        handleClose();
      }
    } catch (error) {
      console.error("Error updating Entry Form data:", error);
    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  };

  const WithDrawEntryForm = async (submission_id) => {
        setLoading(true); // ✅ Start global loader

    const payload = {
      eventId: eventId,
      submissionId: submission_id,
    }
    try {
      const apiUrl = `${USER_EXCHNAGE_URL}/withdrawSubmission`
      const response = await axios.post(apiUrl, payload, {
        headers: {
          "Content-Type": "Application/json",
          authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        console.log("response", response);
        toast.success("Entry withdrawn successfully.")
      }
    } catch (error) {
      console.log(error, "error")
      toast.error("Failed to withdraw entry.")

    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  }

  useEffect(() => {
    getEntryListingFormData();
  }, [token, eventId]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };


  // const sendEntry = async (createdById) => {
  //   try {
  //     const apiUrl = `${USER_EXCHNAGE_URL}/send-pending-payment?eventid=${eventId}&userId=${createdById}`;
  //     const response = await axios.get(apiUrl, {}, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         "Authorization": `Bearer ${token}`,
  //       },
  //     });

  //     if (response.status === 200) {
  //       toast.success("Mail Sent Successfully!");
  //     } else {
  //       toast.error("Failed to Send Mail");
  //     }
  //   } catch (error) {
  //     console.error("Error sending entry:", error);
  //     toast.error("Error Sending Mail");
  //   }
  // };
  const sendEntry = async (createdById) => {
    setSendingMail(true); // 🔥 start loader
    setLoading(true); // ✅ Start global loader

    try {
      const apiUrl = `${USER_EXCHNAGE_URL}/send-pending-payment?eventid=${eventId}&userId=${createdById}`;

      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        toast.success("Mail Sent Successfully!");
      } else {
        toast.error("Failed to Send Mail");
      }
    } catch (error) {
      console.error("Error sending entry:", error);
      toast.error("Error Sending Mail");
    } finally {
      setSendingMail(false);
      setLoading(false); // ✅ Stop global loader
    }
  };
  const getFirstWords = (text, wordCount = 4) => {
    if (!text || typeof text !== "string") return text;
    const words = text.trim().split(/\s+/);
    return words.slice(0, wordCount).join(" ") + (words.length > wordCount ? "..." : "");
  };



  const columns = [
    // Actions column moved to be second (right after Select)
    {
      label: "Status",
      accessor: "status",
    },
    {
      label: "Actions",
      accessor: "actions",
    },
    {
      label: "Submission ID",
      accessor: "submission_id",
    },
    ...(fetchedEntryformData?.formSchema?.registrationFields || []).map((field) => ({
      label: getFirstWords(field.label), // 👈 shortens label to 8 words
      accessor: field.field_name,
    })) || [],
    ...(fetchedEntryformData?.formSchema?.entryFields || []).map((field) => ({
      label: getFirstWords(field.label), // 👈 shortens label to 8 words
      accessor: field.field_name,
    })) || [],
    {
      label: "Created At",
      accessor: "created_at",
    },
    {
      label: "Updated At",
      accessor: "updated_at",
    },
    {
      label: "Payment",
      accessor: "payment",
    }
    // Removed Actions from here as it's now placed at the beginning
  ];


  const entryFieldColumns = [
    ...((fetchedEntryformData?.formSchema?.entryFields || []).map((field) => ({
      label: field.label,
      accessor: field.field_name,
    }))) || [],
  ];

  const data = (fetchedEntryformData?.mergedData || []).flatMap((entry) => {
    const fieldMap = {};

    [...(fetchedEntryformData?.formSchema?.registrationFields || []),
    ...(fetchedEntryformData?.formSchema?.entryFields || [])]
      .forEach(field => {
        const normalizedLabel = field.label.toLowerCase().replace(/\(default\)/gi, '').trim();
        fieldMap[normalizedLabel] = field.field_name;
      });

    console.log(entry, "entry")

    const registrationDetails = {
      submission_id: entry.submissionData?.submission_id,
      registrationFormId: entry.registrationData?.registrationFormId,
      entryFormId: entry.submissionData?.entryFormId,
      created_at: formatDate(entry.submissionData?.created_at),
      updated_at: formatDate(entry.submissionData?.updated_at),
      payment: entry.submissionData?.paymentstatus || "Unpaid",
      CreatedBy: entry?.submissionData?.created_by,
      status: (
        <span
          style={{
            padding: "5px 10px",
            borderRadius: "6px",
            fontSize: "12px",
            fontWeight: "600",
            display: "inline-block",
            color: entry.submissionData?.isDraft === 1 ? "#856404" : "#155724",
            backgroundColor:
              entry.submissionData?.isDraft === 1 ? "#fff3cd" : "#d4edda",
          }}
        >
          {entry.submissionData?.isDraft === 1 ? "Draft" : "Submitted"}
        </span>
      ),
    };

    if (entry.registrationData?.role === "user") {
      entry.registrationData?.fields?.forEach(field => {
        const [key, value] = Object.entries(field).find(([k]) => k !== 'registrationDataId') || [];
        if (key) {
          const normalizedKey = fieldMap[key.toLowerCase().replace(/-/g, ' ')] || key;
          registrationDetails[normalizedKey] = getFirstWords(value);
        }
      });
    }

    if (entry.registrationData?.role === "admin") {
      const adminFields = {
        'first name': entry.registrationData?.first_name,
        'last name': entry.registrationData?.last_name,
        'email': entry.registrationData?.email,
        'country': entry.registrationData?.country
      };

      Object.entries(adminFields).forEach(([label, value]) => {
        const dataName = fieldMap[label.toLowerCase()];
        if (dataName) {
          registrationDetails[dataName] = value;
        }
      });
    }
    const submissions = {};
    entry.submissionData?.fields?.forEach((submissionField) => {
      const [key, value] = Object.entries(submissionField).find(([k]) => k !== 'entryDataId') || [];
      const normalizedKey = fieldMap[key?.toLowerCase()] || key;

      if (!submissions[entry.created_by]) {
        submissions[entry.created_by] = { ...registrationDetails };
      }

      submissions[entry.created_by][normalizedKey] = getFirstWords(value);
      submissions[entry.created_by].actions = (
        <>
          <FaEdit
            style={{ cursor: "pointer", color: "#007bff", marginRight: "8px" }}
            onClick={() => handleEditClick(entry)}
          />
          <FaPaperPlane
            style={{
              cursor: sendingMail ? "not-allowed" : "pointer",
              color: sendingMail ? "#999" : "#28a745",
              marginRight: "8px",
              opacity: sendingMail ? 0.6 : 1,
            }}
            onClick={() => {
              if (!sendingMail) sendEntry(registrationDetails.CreatedBy);
            }}
          />
          <ImBlocked
            style={{ cursor: "pointer", color: "#FF0000" }}
            onClick={() => WithDrawEntryForm(registrationDetails.submission_id)}
          />
          <button
            style={{
              background: "#007bff",
              color: "white",
              border: "none",
              padding: "4px 8px",
              borderRadius: "4px",
              cursor: "pointer",
              marginLeft: "8px",
            }}
            onClick={() =>
              handleMediaClick(entry?.submissionData?.media_files || [])
            }

          >
            Media
          </button>
        </>
      );
    });

    return Object.values(submissions);
  });


  return (
    <div>
      <div className="entry_form_listing_div">
        <TitleBar title="Entry Form Listing" />
        <div className="entry_form_listing_white_bg">
          <TopBar titleheading="Entry Form Listing" />

          <div className="entry_form_listing_table_div">
            <div className="entry_form_listing_table_search">
              <div className="entry_form_listing_table_icon">
                <IoSearchSharp />
              </div>
              <div className="entry_form_listing_table_icon_content">
                <input type="text" placeholder="Search here..." />
              </div>
            </div>

            <div className="entry_form_listing_filter_btn">

              <ViewMoreButton
                style={{ color: "#333333" }}
                onClick={handleSelectAll}
              >
                Select All
              </ViewMoreButton>

              <ViewMoreButton
                style={{ color: "#333333" }}
                onClick={handleDeselectAll}
              >
                Deselect All
              </ViewMoreButton>
              <ViewMoreButton
                style={{ color: "#333333" }}
                onClick={downloadSelectedRecords}
                disabled={selectedRows.length === 0}
              >
                Export CSV
              </ViewMoreButton>

              <ViewMoreButton style={{ color: "#333333" }}>
                Refresh
              </ViewMoreButton>

              <GreyfilterButton className="entry_form_listing_filter_icon">
                <LuFilter />
                Filter
              </GreyfilterButton>
            </div>
          </div>

          <div className="table_container_head">
            <RedMainHeading>Nominee</RedMainHeading>
            <GreenSubDescription>Entry Form</GreenSubDescription>
          </div>

          <div className="table_scroll_wrapper">
            <div className="table_container">
              <GlobalFourthTable
                data={data}
                columns={columns}
                selectedRows={selectedRows}
                onCheckboxChange={(rowId, checked) => handleCheckboxChange(rowId, checked)}
                onRowClick={handleRowClick}
              />
            </div>
          </div>

        </div>
      </div>

      <Modal show={showModal} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Edit Entry Form Listing Data</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="juryassign_cont">
            <div className="juryassign_heading">
              <SubHeading>Edit Entry Form Listing</SubHeading>
            </div>

            {/* 🔥🔥🔥 MAIN CHANGE: STATIC FORM REMOVED */}

            <AdminEdit
              isEdit={true}
              initialData={formValues}
              submissionId={submissionId}
              entryFormId={entryFormId}
              eventId={eventId}
              submissionUserId={submissionUserId} // ✅ ADD

            />

            {/* 🔥 REMOVE OLD BUTTONS (User form already has submit/update) */}
          </div>
        </Modal.Body>
      </Modal>

      {isMediaModalOpen && (
        <div className="media-modal-wrapper">
          <div className="media-modal">
            <button
              className="close-btn"
              onClick={() => setIsMediaModalOpen(false)}
            >
              &times;
            </button>

            <h2>📁 Media Files</h2>

            <ul>
              {mediaList.map((file) => (
                <li key={file.id}>
                  <div className="file-info">
                    <span>{file.mimeType.includes("image") ? "🖼️" : "📎"}</span>
                    <span>{file.name}</span>
                  </div>
                  <button onClick={() => handleSingleMediaClick(file)}>View</button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

    </div>
  );
};  
